import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useTranslation } from 'react-i18next'

export default function NoPermission() {
  const navigate = useNavigate();

  const { t } = useTranslation()

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 40,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: 60, color: 'error.main', mb: 2 }} />
        <Typography component="h1" variant="h4" gutterBottom>
            {t('no_access')}
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
            {t('no_access_text')}
        </Typography>
      </Box>
    </Container>
  );
}
